import Dom from '../../helpers/dom-helper';
import AboutModal from './about/about-modal';
import modalTemplate from './modal.html';
import ShareModal from './share/share-modal';

const MODAL_TEMPLATE = modalTemplate();
const BODY_OVERLAY_OPEN_CLASSNAME = 'overlay-open';
const BODY_MODAL_OPEN_CLASSNAME = 'modal-open';

export default class Modal {
    constructor(domManager, eventLogger = null, eventBus, privacyPolicyUrl) {
        this.domManager = domManager;
        this.eventLogger = eventLogger;
        this.eventBus = eventBus;
        this.privacyPolicyUrl = privacyPolicyUrl;
        this.element = null;
        this.isOpen = false;

        this.modals = {
            about: null,
            share: null
        };
        // references to different constructors
        // to be able to map during initialisation
        this.constructors = {
            share: ShareModal,
            about: AboutModal
        };

        this.init();
    }

    /**
     * Initialize the modal
     */
    init() {
        this.render();
    }

    /**
     * Open a particular modal (about, share, ..)
     * @param {String} type
     * @param {Object} data
     */
    open(type, data) {
        this.isOpen = true;

        // update view state
        Dom.addClass(BODY_OVERLAY_OPEN_CLASSNAME, this.domManager.get('body'));
        Dom.addClass(BODY_MODAL_OPEN_CLASSNAME, this.domManager.get('body'));

        if (!this.modals[type]) {
            this.modals[type] = new this.constructors[type](this, data);
        }
    }

    /**
     * Close and delete a particular modal
     * @param {String} type
     */
    close(type) {
        this.isOpen = false;

        Dom.removeClass(BODY_OVERLAY_OPEN_CLASSNAME, this.domManager.get('body'));
        Dom.removeClass(BODY_MODAL_OPEN_CLASSNAME, this.domManager.get('body'));

        this.eventBus.dispatch('modal:close');

        delete this.modals[type];
    }

    /**
     * Render the modal in the DOM
     */
    render() {
        if (this.element !== null) {
            throw new Exception('ShareModal already rendered');
        }

        this.element = Dom.createElement(MODAL_TEMPLATE);
        this.domManager.get('body').appendChild(this.element);

        // cache our modal element in our dom manager
        this.domManager.set('modal-wrapper', document.querySelector('.modal-wrapper'));
        this.domManager.set('modal', document.querySelector('.modal'));
    }
}
